angular.module('populationioApp').controller('SummaryCtrl', [
	'$scope', '$interval', '$filter', '$translate', 'PopulationIOService', 'ProfileService',
	function($scope, $interval, $filter, $translate, PopulationIOService, ProfileService){
		'use strict';
		var calculateRanks = function(){
			if ($scope.rankLocal === undefined || $scope.rankGlobal === undefined ||
				$scope.worldPopulation === undefined || $scope.countryPopulation === undefined) {
				return;
			}
			$scope.worldYoungerPercentageSimple = Math.min(100, $scope.rankGlobal / ($scope.worldPopulation / 100));
			$scope.countryYoungerPercentageSimple = Math.min(100, $scope.rankLocal / ($scope.countryPopulation / 100));
			$scope.scaledRankOlderLocal = $scope.countryPopulation - $scope.rankLocal;
			$scope.scaledRankOlderGlobal = $scope.worldPopulation - $scope.rankGlobal;
		};
		$scope.region = 'World';
		$scope.profile = ProfileService;
		$scope.age = new Date().getFullYear() - ProfileService.birthday.year;
		if (ProfileService.rankGlobal > -1) {
			$scope.rankGlobal = ProfileService.rankGlobal;
			calculateRanks();
		}
		if (ProfileService.rankLocal > -1) {
			$scope.rankLocal = ProfileService.rankLocal;
			calculateRanks();
		}
		if (ProfileService.rankGlobalTomorrow > -1) {
			$scope.rankGlobalTomorrow = ProfileService.rankGlobalTomorrow;
			if ($scope.rankGlobal) {
				$scope.deltaRankGlobal = Math.ceil(($scope.rankGlobalTomorrow - $scope.rankGlobal) / (24 * 60 * 60));
			}
		}
		if (ProfileService.rankLocalTomorrow > -1) {
			$scope.rankLocalTomorrow = ProfileService.rankLocalTomorrow;
		}
		calculateRanks();
		$scope.$watch('worldPopulation', calculateRanks);

		$scope.calcWorldOlderNumber = function(){
			if(!$scope.rankGlobal || !$scope.worldPopulation){
				return 0;
			}
			return $filter('number')(Math.max(0, $scope.worldPopulation - $scope.rankGlobal), 0);
		};
		$scope.calcWorldOlderPercentage = function(){
			var value = $filter('number')(Math.max(0, 100 - $scope.rankGlobal / ($scope.worldPopulation / 100)), 0);
			return $translate.instant('SUMMARY_PEOPLE_OLDER') + value + '%)';
		};
		$scope.calcCountryOlderNumber = function(){
			return $filter('number')(Math.max(0, $scope.countryPopulation - $scope.rankLocal), 0);
		};
		$scope.calcCountryOlderPercentage = function(){
			var value = $filter('number')(Math.max(0, 100 - $scope.rankLocal / ($scope.countryPopulation / 100)), 0);
			return $translate.instant('SUMMARY_PEOPLE_OLDER') + value + '%)';
		};
		$scope.calcCountryYoungerPercentage = function(){
			var value = $filter('number')(Math.min(100, $scope.rankLocal / ($scope.countryPopulation / 100)), 0);
			return $translate.instant('SUMMARY_PEOPLE_YOUNGER') + value + '%)';
		};
		$scope.calcWorldYoungerPercentage = function(){
			var value = $filter('number')(Math.min(100, $scope.rankGlobal / ($scope.worldPopulation / 100)), 0);
			return $translate.instant('SUMMARY_PEOPLE_YOUNGER') + value + '%)';
		};
		$scope.selectWorld = function(){
			$scope.region = 'World';
			//noinspection JSUnresolvedFunction
			ga('send', 'event', 'SummaryChartType', 'World');
		};
		$scope.selectCountry = function(){
			$scope.region = $scope.profile.country;
			//noinspection JSUnresolvedFunction
			ga('send', 'event', 'SummaryChartType', 'Country');
		};
		$scope.$on('rankLocalChanged', function(event, rank){
			$scope.rankLocal = rank;
		});
		$scope.$on('rankGlobalChanged', function(event, rank){
			$scope.rankGlobal = rank;
			$scope.deltaRankGlobal = Math.ceil(($scope.rankGlobalTomorrow - $scope.rankGlobal) / (24 * 60 * 60));
		});
		$scope.$on('rankDateLocalChanged', function(event, rank){
			$scope.rankLocalTomorrow = rank;
		});
		$scope.$on('rankDateGlobalChanged', function(event, rank){
			$scope.rankGlobalTomorrow = rank;
			$scope.deltaRankGlobal = Math.ceil(($scope.rankGlobalTomorrow - $scope.rankGlobal) / (24 * 60 * 60));
		});
		$scope.$on('countryPopulationDataChanged', function(event, data){
			$scope.countryPopulationData = data;
			var population = 0;
			for (var i in data) {
				if (!data.hasOwnProperty(i)) {
					continue;
				}
				population += data[i].total;
			}
			$scope.countryPopulation = population;
			calculateRanks();
		});
		$scope.$on('worldPopulationDataChanged', function(event, data){
			$scope.worldPopulationData = data;
		});
		$interval(function(){
			if ($scope.deltaRankGlobal) {
				$scope.rankGlobal += $scope.deltaRankGlobal;
				$scope.$root.$broadcast('rankGlobalChanged', $scope.rankGlobal);
			}
		}, 1000);
	}
]);
